import React, { useEffect, useRef, useState } from 'react';
import { actionIcons } from '../../../../configs/Icons';
import { useInit } from '../../../Contexts/InitProvider';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import Button from '../../../utils/Button';
import InputField, { SelectOption, addOption } from '../../../utils/InputField';
import { CrossIcon, FilterIconLine, PlusIcon } from '../../../utils/SVGIcon';
import cn from '../../../utils/cn';
import { useSupportTicket } from '../SupportTicketProvider';

function OverlyFilterModal({
    setShowFilterModal,
    isShow,
    handleChangeFilterData,
    p,
    onResetFilter
}) {
    const { initInfo } = useInit();
    const { addressTypes } = initInfo;
    const ref = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowFilterModal(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setShowFilterModal]);
    return (
        <div
            className={cn(
                'fixed w-full h-full top-0 left-0 overflow-hidden bg-primary bg-opacity-50 z-50 flex justify-end transition-all duration-700 ',
                {
                    'left-full bg-opacity-0': !isShow
                }
            )}
        >
            <div className="bg-white w-[80%] h-full" ref={ref}>
                <div className="flex justify-between items-center px-4 py-2 border-b border-primary-200">
                    <h3 className="text-lg font-semibold">Filter</h3>
                    <button
                        type="button"
                        onClick={() => setShowFilterModal(false)}
                        className="focus:outline-none rounded-full  bg-error/15 text-error w-[20px] h-[20px] p-1 inline-flex items-center justify-center"
                    >
                        <CrossIcon className="h-full w-full" />
                    </button>
                </div>
                <div className="px-4 py-2">
                    <div className="flex justify-between items-center flex-col gap-4">
                        <SelectOption
                            name="department"
                            placeholder="Department"
                            formData={p}
                            onChange={handleChangeFilterData}
                            options={addressTypes?.map(({ key, title }) =>
                                addOption(key, title, key)
                            )}
                            className="rounded-xl"
                        />
                        <SelectOption
                            placeholder="Status"
                            name="status"
                            formData={p}
                            onChange={handleChangeFilterData}
                            options={['Open', 'Closed']?.map((d) =>
                                addOption(d, d, d?.toLowerCase())
                            )}
                        />
                        <div className="flex justify-end w-full">
                            <Button title="Reset" className="bg-error" onClick={onResetFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SupportTicketHeaderMobile({ handleChangeFilterData, p, onResetFilter }) {
    const { handleReload, openModal } = useSupportTicket();
    const [showFilterModal, setShowFilterModal] = useState(false);
    return (
        <div className="mb-2.5">
            <OverlyFilterModal
                setShowFilterModal={setShowFilterModal}
                isShow={showFilterModal}
                handleChangeFilterData={handleChangeFilterData}
                p={p}
                onResetFilter={onResetFilter}
            />
            <div className="input-with-filter flex justify-between items-center">
                {/* Input Field */}
                <div className="input-box w-50 px-0.5 flex justify-start items-center border border-primary-200 rounded-lg bg-white">
                    <button type="button" className="size-[35px] min-w-max p-[7px] rounded-lg">
                        <img
                            src={actionIcons.searchW}
                            alt=""
                            className="w-full h-full object-cover"
                        />
                    </button>
                    <InputField
                        name="q"
                        placeholder="Search...."
                        formData={p}
                        onChange={handleChangeFilterData}
                        className="*:border-none *:h-full"
                    />
                    {/* Filter Modal Open */}
                    <button
                        type="button"
                        onClick={() => setShowFilterModal(true)}
                        className="flex-1 min-w-max w-[31px] h-[31px] px-[7px] py-[5px] bg-secondary text-white rounded-lg focus:outline-none"
                    >
                        <FilterIconLine />
                    </button>
                </div>
                {/* Action Button */}
                <div className="button-list flex items-center gap-[5px]">
                    <ReloadButton
                        className="!size-[35px] focus:outline-none"
                        onClick={handleReload}
                    />
                    {/* Customer add */}
                    <button
                        type="button"
                        onClick={() => openModal('add-issue')}
                        className="size-[35px] p-[7px] bg-secondary text-white rounded-lg focus:outline-none"
                    >
                        <PlusIcon />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SupportTicketHeaderMobile;
